import type { FaireProductEntity } from "../../entity_types/product";

export const p_nt3t62eqsq: FaireProductEntity = {
  token: "p_nt3t62eqsq",
  type: "product",
  name: "Lion's Mane - Fruiting Body - 1:1 Water Extracted - Organic",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/11ba934ed0b5922fb92ab380df6fdfe7b78e6cc8c0a1b318506ae15e68e87686.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1130787a0af55b0dccb42c27c2a063e05d86e49800b165ac44f8df45a79490a1.png",
    "https://cdn.faire.com/fastly/25362c0fc9172aa4f6dac6817d80ddee4fb43613b71e854c9ecc293a196cec91.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "\nLion's Mane is known for it's neuroregenerative properties that support cognition and focus.*\n\nOur Lion's Mane is organically cultivated in its favorite substrates (no starch, grains, or fillers) and 1:1 water extracted for bioavailability.\n\nFun Fact: In Japan, Lion’s Mane was called Yamabushitaki after a sect of Buddhist monks who used it to increase focus in meditation. These monks wore long strands of fur around their necks to resemble Lion’s Mane.\n\nBETA GLUCANS | 600mg per serving\n\nSERVINGS | 2 grams, 31 servings per package\n\n✓ Always grown outdoors in hoop houses, not in labs.\n\n✓ Triple tested for safety & Mushroom compounds\n\n\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease or health condition. ",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:45.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
